// 攝影機時區標示（ls-loop MW、F20「顯示攝影機時區並標示」）：回放 / 事件頁標題旁。
// 時間以攝影機時區顯示（lib/camTz，對齊 Android 觀看 App）；跟這台電腦不同時明講，避免看錯。
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiFetch } from '../lib/api';
import { ianaForPosix, offsetLabel } from '../lib/phoneCam';

export function CameraTzNote({ deviceId, tz }: { deviceId?: string; tz?: string | null }) {
  const { t } = useTranslation();
  const [posix, setPosix] = useState<string | null>(tz ?? null);
  useEffect(() => {
    if (tz !== undefined || !deviceId) return;
    let alive = true;
    apiFetch<{ tz?: string }>(`/v3/devices/${encodeURIComponent(deviceId)}`)
      .then((r) => { if (alive) setPosix(r.data?.tz ?? null); })
      .catch(() => {});
    return () => { alive = false; };
  }, [deviceId, tz]);
  const iana = ianaForPosix(tz ?? posix);
  if (!iana) return null;
  const cam = offsetLabel(iana);
  const local = offsetLabel(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const same = cam === local;
  return (
    <span data-testid="camera-tz" className={same ? 'text-secondary' : 'text-danger'} style={{ fontSize: 'var(--font-size-sm)', fontWeight: same ? undefined : 600 }}>
      {same ? t('phonecam.cameraTz', { label: cam }) : t('phonecam.tzDiffers', { local, cam })}
    </span>
  );
}
